import styled from 'styled-components';

export const Container = styled.div`
grid-area: MC;
background-color: #f6f7fb;
color:${props => props.theme.colors.white};
height: 100vh;
overflow-y: scroll;
`